import type Owner from '@ember/owner';

import moment from 'moment';

import { TrackingEvent } from 'webapp/enums/tracking';
import { UserSettingsKey } from 'webapp/enums/user-settings';

import type { Args } from 'webapp/components/popup/inner/modal';
import UserPopupInvitePromoBaseComponent from 'webapp/components/user/popup-invite-promo-base';

export default class UserPopupInvitePromoSourceComponent extends UserPopupInvitePromoBaseComponent {
	constructor(owner: Owner, args: Args) {
		super(owner, args);

		void this.userSettingsService.save(
			UserSettingsKey.INVITE_USER_SOURCE_PROMO_POPUP_SHOWN_TIMESTAMP,
			moment().unix(),
		);

		this.analyticsService.event(TrackingEvent.INVITE_USER_PROMO_SHOWN, {
			type: 'datasource',
		});
	}

	get image() {
		return '/images/invite-users-promo-source.png';
	}

	get title() {
		return 'Who in your team can help you connecting more tools?';
	}
}
